import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ReactTooltip from "react-tooltip";
import { resetCursor, toTitleCase } from "../../../../config/utils";
import imgProcess from "../../../../assets/img/img-process.svg";

import Loader from "../Loader";
import { sanitizeHtml } from "../SafeHtml";

function ImageList({
    imageData,
    hasMore,
    fetchMoreImages,
    handleSelect,
    handleClickImage,
    hasCheckBox,
    imagesNotUsedIds,
    checkIfNarrativeImageUsed,
    isReportImage,
    hasViewRecom,
    viewRecommendations,
    hasEdit,
    handleEdit,
    handleDelete,
    hasDelete,
    updateImageFromInfoImages1,
    handleInputCaptionData,
    handleMultiSelectImage,
    selectedImages,
    isAsset,
    hasCaptionEdit = true
}) {
    const ref = useRef(null);
    // const inputRef = useRef(null);
    const [toggleInput, setToggleInput] = useState({});
    const [caption, setCaption] = useState({
        id: "",
        description: ""
    });

    useEffect(() => {
        // inputRef && inputRef.current && inputRef.current.focus();
        document.addEventListener("click", handleClickOutside, true);
        ReactTooltip.rebuild();
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, [toggleInput]);

    const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target)) {
            handleClick("");
        }
    };

    const handleClick = key => {
        setToggleInput(prevState => {
            return { ...prevState, toggleInput: toggleInput === key ? "" : key || "" };
        });
    };
    const handleInputCaption = async () => {
        await handleInputCaptionData(caption);
        handleClick("");
        updateImageFromInfoImages1(caption);
        ReactTooltip.rebuild();
    };
    const handleGetImageId = (id, value) => {
        if (hasCaptionEdit) {
            setCaption({
                id: id,
                description: value
            });
            handleClick(id);
        }
    };
    const moveCaretAtEnd = e => {
        var temp_value = e.target.value;
        e.target.value = "";
        e.target.value = temp_value;
    };

    const getImageUrl = image => {
        let imageUrl = "";
        if (image) {
            const { is_edited, s3_ethumbnail_key, s3_thumbnail_key } = image;
            imageUrl = is_edited ? s3_ethumbnail_key : s3_thumbnail_key;
        }
        return imageUrl;
    };
    return (
        <>
            <InfiniteScroll
                dataLength={imageData?.length}
                next={fetchMoreImages}
                hasMore={hasMore}
                height={600}
                loader={
                    <div className="col-12">
                        <Loader />
                    </div>
                }
                className="d-flex flex-wrap infinite-scroll"
                endMessage={<p style={{ textAlign: "center" }}>{/* <b>No more data</b> */}</p>}
            >
                <div className="listing-items">
                    {imageData?.length
                        ? imageData.map((item, idx) => (
                              <div className={`list-item`} key={`img-list-items-${item.id}-${idx}`}>
                                  <div class="drop-sec">
                                      <div class="image-right d-flex">
                                          {item.hasOwnProperty("printable") && (
                                              <div class="mr-2 recom">
                                                  {imagesNotUsedIds && !imagesNotUsedIds.includes(item.id) && item.printable ? (
                                                      <img
                                                          src="/img/check_green.svg"
                                                          height={26}
                                                          width={26}
                                                          alt=""
                                                          data-for={item.id}
                                                          data-tip={"Used"}
                                                      />
                                                  ) : (
                                                      <img
                                                          src="/img/check_green red.svg"
                                                          height={26}
                                                          width={26}
                                                          alt=""
                                                          data-for={item.id}
                                                          data-tip={"Not Used"}
                                                      />
                                                  )}
                                              </div>
                                          )}
                                          {hasViewRecom && (
                                              <div className="recom" onClick={() => viewRecommendations(item.recommendation_id)}>
                                                  <i className="fa fa-file-alt" data-for={item.id} data-tip={"View Recommendation"}></i>
                                              </div>
                                          )}
                                          {hasEdit && (
                                              <div className="icon" onClick={() => handleEdit(item)}>
                                                  <i className="fa fa-pencil-alt" data-for={item.id} data-tip={"Edit"}></i>
                                              </div>
                                          )}
                                          {hasDelete && (
                                              <div className="icon" onClick={() => handleDelete(item.id)}>
                                                  <i className="fas fa-trash cursor-pointer" data-for={item.id} data-tip={"Remove"}></i>
                                              </div>
                                          )}
                                      </div>
                                  </div>
                                  <div
                                      className="cnt-area cursor-hand"
                                      //   onClick={() => handleClickImage(item)}
                                  >
                                      <div className="img-section">
                                          {getImageUrl(item.master_image ?? item) ? (
                                              <LazyLoadImage
                                                  alt={`img-${idx}`}
                                                  onClick={() => handleClickImage(item)}
                                                  effect="blur"
                                                  className="img-itm"
                                                  src={getImageUrl(item.master_image ?? item)}
                                              />
                                          ) : (
                                              <div className="image-preview">
                                                  <div class="img-process-sec">
                                                      <img src={imgProcess} alt="processing" />
                                                      <h3>Processing..</h3>
                                                  </div>
                                              </div>
                                          )}

                                          {!isAsset && (
                                              <label class="container-check">
                                                  <input
                                                      type="checkbox"
                                                      checked={selectedImages?.find(selectedImage => selectedImage?.id === item?.id)}
                                                      onChange={e => handleMultiSelectImage(item, e.target.checked)}
                                                  />
                                                  <span class="checkmark"></span>
                                              </label>
                                          )}

                                          {/* {hasCheckBox && (
                                              <>
                                                  {isReportImage ? (
                                                      <label
                                                          class="container-check"
                                                          data-for={item.id}
                                                          data-tip={item.printable ? "Disable in Narrative" : "Enable in Narrative"}
                                                          onClick={() => handleClickImage(item)}
                                                      >
                                                          <input
                                                              type="checkbox"
                                                              checked={item.printable}
                                                              onChange={() => checkIfNarrativeImageUsed(item, !item.printable)}
                                                          />
                                                          <span class="checkmark"></span>
                                                      </label>
                                                  ) : (
                                                      <label
                                                          class="container-check"
                                                          data-for={item.id}
                                                          data-tip="Set as Default"
                                                          onClick={() => handleClickImage(item)}
                                                      >
                                                          <input
                                                              type="checkbox"
                                                              checked={item.default_image}
                                                              onChange={() => handleSelect(item, !item.default_image)}
                                                          />
                                                          <span class="checkmark"></span>
                                                      </label>
                                                  )}
                                              </>
                                          )} */}
                                      </div>
                                      <div className="cnt-sec-itm">
                                          {toggleInput.toggleInput === item.id ? (
                                              <>
                                                  {/* {caption.id === item.id &&  */}
                                                  <label htmlFor="">
                                                      <>
                                                          <div>
                                                              <h3 style={{ textTransform: "none", cursor: "pointer" }}>
                                                                  {item?.description || item?.caption || "-"}
                                                              </h3>
                                                              <textarea
                                                                  className="floating-textarea img-list-float-area"
                                                                  type="text"
                                                                  // maxLength={this.state.captionMaxLength}
                                                                  //   ref={inputRef}
                                                                  value={caption.description}
                                                                  onChange={e => {
                                                                      resetCursor(e);
                                                                      let updatedValue = {};
                                                                      updatedValue = { description: toTitleCase(e.target.value) };
                                                                      setCaption(caption => ({ ...caption, ...updatedValue }));
                                                                  }}
                                                                  //   onBlur={() => setToggleInput("")}
                                                                  onKeyPress={event => {
                                                                      if (event.key === "Enter") {
                                                                          handleInputCaption();
                                                                      }
                                                                  }}
                                                                  placeholder="Caption"
                                                                  onDoubleClick={() => handleClick("")}
                                                                  autoFocus
                                                                  onFocus={moveCaretAtEnd}
                                                                  data-place="bottom"
                                                                  data-effect="solid"
                                                                  data-for={item.id}
                                                                  data-tip={
                                                                      "Please Click Enter key to Update<br/>Or<br/>Double Click  to Go Back<br/>"
                                                                  }
                                                              />
                                                          </div>
                                                      </>
                                                  </label>
                                                  {/* } */}
                                              </>
                                          ) : (
                                              <h3
                                                  onDoubleClick={() => handleGetImageId(item.id, item?.description ?? item?.caption)}
                                                  style={{ textTransform: "none", cursor: "pointer" }}
                                                  data-for={item.id}
                                                  html={true}
                                                  data-tip={
                                                      hasCaptionEdit
                                                          ? item?.description ?? item?.caption
                                                              ? `Double Click Here to Edit Caption <br/> ${item?.description ?? item?.caption}`
                                                              : "Double Click Here to Add Caption<br/>"
                                                          : ""
                                                  }
                                              >
                                                  {item?.description || item?.caption || "-"}
                                              </h3>
                                          )}
                                          <div onClick={() => handleClickImage(item)} className="item-sub">
                                              File name : {item?.master_image?.name ?? item?.name}
                                          </div>
                                          <div onClick={() => handleClickImage(item)} className="item-sub">
                                              Trade : {item?.master_image?.trade?.name ?? item?.trade?.name}
                                          </div>
                                          <div onClick={() => handleClickImage(item)} className="item-sub">
                                              Building :{item?.master_image?.building?.name ?? item?.building?.name}
                                          </div>
                                          <div onClick={() => handleClickImage(item)} className="item-sub">
                                              Date Taken :{" "}
                                              {moment(item?.master_image?.meta_data?.date_taken ?? item?.meta_data?.date_taken).format(
                                                  "dddd, MMMM Do YYYY, h:mm a"
                                              ) || "-"}
                                          </div>
                                      </div>
                                  </div>
                                  <ReactTooltip
                                      id={item.id}
                                      effect="solid"
                                      backgroundColor="#1383D9"
                                      multiline={true}
                                      getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                                  />
                              </div>
                          ))
                        : null}
                </div>
            </InfiniteScroll>
        </>
    );
}

export default ImageList;
